import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { LinkedinIcon, FacebookIcon, InstagramIcon } from '../../../assets';
import { LanguageContext } from '../../../context/LanguageContext';

const IconListContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

  & > *:not(:last-child) {
    margin-right: 10px;
  }

  svg {
    cursor: pointer;
    width: 40px;
    height: 40px;
    path {
      fill: ${({ isInverted, theme: { colors } }) => (!isInverted ? colors.white : colors.primaryColor)};
    }
  }
`;

const IconItem = styled.div`
  display: flex;
  align-items: center;
  svg {
    path {
      fill: ${({ isInverted, theme: { colors } }) => (!isInverted ? colors.white : colors.secondaryColor)};
    }
  }
`;

const IconList = ({ isInverted }) => {
  const { language } = useContext(LanguageContext);
  /// ADD-LINKS
  const socialLinks = {
    FACEBOOK: {
      icon: <FacebookIcon />,
      itLink: 'https://www.facebook.com/ledgerthings/',
      usLink: 'https://www.facebook.com/ledgerthings/'
    },
    INSTAGRAM: {
      icon: <InstagramIcon />,
      itLink: 'https://www.instagram.com/ledgerthings/',
      usLink: 'https://www.instagram.com/ledgerthings/'
    },
    LINKEDIN: {
      icon: <LinkedinIcon />,
      itLink: 'https://www.linkedin.com/company/ledger-things/',
      usLink: 'https://www.linkedin.com/company/ledger-things/'
    }
  };
  return (
    <IconListContainer isInverted={isInverted}>
      {Object.values(socialLinks).map((social, index) => (
        <IconItem
          key={index}
          isInverted={isInverted}
          onClick={() => {
            window.open(language.toUpperCase() === 'IT' ? social.itLink : social.usLink, '_blank', 'noopener,noreferrer');
          }}
        >
          {social.icon}
        </IconItem>
      ))}
    </IconListContainer>
  );
};

export default IconList;
